import { createActions } from 'redux-actions';

export const { updateReferrer, updateNavigationHistory } = createActions(
  'UPDATE_REFERRER',
  'UPDATE_NAVIGATION_HISTORY',
);
